import { Box, Button, Typography } from '@material-ui/core';
import { SentimentDissatisfied } from '@material-ui/icons';
import React, { FunctionComponent } from 'react';
import { emptyStateStyles } from 'styles/emptyState';

interface EmptyStateI {
  title: string;
  subTitle: string;
  onBtnClick?: () => void;
  btnLabel?: string;
  compact?: boolean;
}

const EmptyState: FunctionComponent<EmptyStateI> = ({
  title,
  subTitle,
  onBtnClick,
  btnLabel,
  compact = false
}: EmptyStateI) => {
  const classes = emptyStateStyles();

  const titleTypographyVariant = compact ? 'body2' : 'subtitle1';
  const buttonVariant = compact ? 'text' : 'outlined';

  return (
    <Box className={classes.root}>
      <Box className={classes.icon}>
        <SentimentDissatisfied color="primary" />
      </Box>
      <Box className={classes.textbox}>
        {title && (
          <Typography
            className={classes.title}
            variant={titleTypographyVariant}
            color="primary"
          >
            {title}
          </Typography>
        )}
        {subTitle && (
          <Typography
            className={classes.subtitle}
            variant="body2"
            color="textSecondary"
          >
            {subTitle}
          </Typography>
        )}
        {onBtnClick && (
          <Button variant={buttonVariant} color="primary">
            {btnLabel}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default EmptyState;

EmptyState.defaultProps = {
  onBtnClick: undefined,
  btnLabel: undefined,
  compact: false
};
